import { ClipboardX } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FormCancelledBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-neutral-200 font-semibold text-neutral-500">
      <ClipboardX aria-hidden />
      {t('component:badge.formCancelled')}
    </Badge>
  );
};
